const loginBtn = document.querySelector('.login-btn');
const loginDrawer = document.querySelector('.login__drawer');


loginBtn.addEventListener("mouseenter", event =>{
    loginDrawer.classList.remove('header__submenu-hidden');
    loginBtn.classList.add("header__menu-item-active");
    menuWrapper.addEventListener("mouseleave", (event) => {
        loginDrawer.classList.add("header__submenu-hidden");
         loginBtn.classList.remove("header__menu-item-active");
      });
})


